import {
  LogDevMessageKinds,
  makeLogDevMessage,
} from '@/shared/helpers/make-log-dev-message';

import { type UserType } from '../model/user.types';
import { type Wallet } from '../model/wallet.types';

export const logWalletChanges = makeLogDevMessage<Wallet[], boolean>(
  LogDevMessageKinds.ws,
  'WALLET',
  ['STORE UPDATE', (_, isPaused) => (isPaused ? 'PAUSED' : 'ENABLED')],
  ['Message', (wallets) => wallets]
);

export const formatUserName = (
  user: Partial<Pick<UserType, 'firstName' | 'lastName' | 'username'>> | null | undefined
) => {
  if (!user) return null;

  if (user.firstName || user.lastName) {
    return [user.firstName, user.lastName].filter(Boolean).join(' ');
  }

  return user.username ? `@${user.username}` : null;
};
